import { Injectable } from '@angular/core';
import { Http, Headers ,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { URL_SERVICIOS_LOCALES } from '../../config/url.servicio';

@Injectable()
export class DepartamentosProvider {

  constructor(public http: Http) {
    console.log('Hello DepartamentosProvider Provider');
  }

  buscar() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=departamentos`)
      .map((data)=> data.json())
  }

  buscarTodo(name:string) {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=${name}`)
      .map((data)=> data.json())
  }

  guardar(departamentos: any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

    return this.http.post(`${url}/query`, departamentos, options)
      .map((data) => data.json()
       , error => console.log(error))
  }


  guardarTodo(data: any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

    return this.http.post(`${url}/query`, data, options)
      .map((data) => data.json()
       , error => console.log(error))
  }

  actualizar(departamentos: any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })
    return this.http.put(`${url}/query`, departamentos, options)

  }

  eliminar(departamentos: any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&departamentosId=${departamentos.departamentosId}&nombreTabla=departamentos`, options)
  }

  eliminarTodo(ubicacion: any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&ubicacionId=${ubicacion.ubicacionId}&nombreTabla=ubicacion`, options)
  }

}



// WEBPACK FOOTER //
// ./src/providers/departamentos/departamentos.ts